import React, { Component } from "react";
import { Form, Col, Row, Button, Table, InputGroup } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import RetailDiscountCouponDetail from "./RetailDiscountCouponDetail";

import "../../assets/styles/RetailPortal.css";
import { get, post, sess_get, sess_post } from "../../utils/HttpRequests";


class RetailPortalCreateNewCoupons extends Component {
  constructor() {
    super();
    this.state = {
      code: "DO*****",
      active: false,
      plans: [],
      start_date: "",
      expiry_date: "",
      error: {
        code: "",
        numbers: "",
      },
      isSubmitting: false,
      hasErrors: false,
      percentage: 0,
      percentageCap: 0,
      type: "flat",
      flat: 0,
      planType: "all",
      allPlans: [],
      quantity: 0,
    };
  }

  async componentDidMount() {
    const session_token = localStorage.getItem("admin-panel-sessionToken");
    let plans = await sess_get("admin/console/get-plans", session_token);
    let allPlans = [];
    if (
      plans &&
      plans.data &&
      plans.data.response &&
      plans.data.response.plans
    ) {
      plans = plans.data.response.plans;
    } else {
      plans = [];
    }
    plans.forEach((p) => (p.quantity = 0));
    allPlans = plans;
    this.setState({
      ...this.state,
      plans,
      allPlans,
    });
  }

  hasErrors() {
    let { error } = this.state;
    for (let i in error) {
      if (error[i]) {
        return true;
      }
    }
    return false;
  }

  setErrorStatus() {
    let hasErrors = this.hasErrors();
    this.setState({
      ...this.state,
      hasErrors,
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({
      ...this.state,
      isSubmitting: true,
    });
    this.createNewCouponsForRetailStore().then((d) => {
      if (d && d.error) {
        this.setState({
          ...this.state,
          isSubmitting: false,
        });
        toast.error(`We were unable to add the store,${d.error}`, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        this.props.history.push("/retail");
        toast.success("Coupon Added!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    })
      .catch(error => {

      })
  };

  createNewCouponsForRetailStore = async () => {
    const session_token = localStorage.getItem("admin-panel-sessionToken");

    let { plans } = this.state;
    if (!plans || !plans.length) {
      plans = null;
    }
    return sess_post(
      "admin/console/retail-portal/create-new-coupons",
      session_token,
      { ...this.state, store_id: this.props.store_id }
    )
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          let { error } = err.response.data;
          console.error(error);
          return { error: error.reason };
        }
        return { error: err.toString() };
      });
  };

  handleOnChange = (ev, d) => {
    let val = ev.target.value;
    let id = ev.target.id;

    let { error } = this.state;
    error[id] = "";
    let codeError = "";
    if (!val) {
      error[id] = "Must not be empty";
    }
    if (id === "code" && (val.length < 6 || val.length > 20)) {
      error[id] = "Code Length must be between 6 and 30 characters long";
    }

    this.setState(
      {
        ...this.state,
        [ev.target.id]: ev.target.value,
        error,
      },
      this.setErrorStatus
    );
  };

  handlePlan = (ev, plan) => {
    let { plans } = this.state;
    plans.forEach((p) => {
      if (p._id === plan._id) {
        p.quantity = ev.target.value;
      }
    });

    this.setState({
      ...this.state,
      plans,
    });
  };

  handleActiveChange = async (event) => {
    let active = event.target.checked;
    this.setState({
      ...this.state,
      active,
    });
  };

  handleDiscountType = async (event) => {
    let type = event.target.value;
    let state = {
      ...this.state,
    };
    state.type = type;
    if (type == "flat") {
      state.percentage = 0;
      state.percentageCap = 0;
    } else if (type == "percentage") {
      state.flat = 0;
    }
    this.setState({ ...state });
  };

  handleFlatChange = async (event) => {
    let flat = event.target.value;
    if (flat < 0) flat = 0;
    this.setState({
      ...this.state,
      flat,
    });
  };

  handlePercentageChange = async (event) => {
    let percentage = event.target.value;
    if (percentage < 0) {
      percentage = 0;
    } else if (percentage > 100) {
      percentage = 100;
    }
    this.setState({
      ...this.state,
      percentage,
    });
  };

  handlePercentageCapChange = async (event) => {
    let percentageCap = event.target.value;
    if (percentageCap < 0) {
      percentageCap = 0;
    }
    this.setState({
      ...this.state,
      percentageCap,
    });
  };

  handlePlanType = async (event) => {
    this.setState({
      ...this.state,
      plans: this.state.allPlans,
      quantity: 0,
      [event.target.id]: event.target.value,
    });
  };

  handleAssignCouponsToAllPlans = async (event) => {
    const quantity = event.target.value;
    const { allPlans } = this.state;
    const plans = allPlans.map((plan) => {
      return { ...plan, quantity };
    });
    this.setState({
      ...this.state,
      quantity,
      plans,
    });
  };

  render() {
    return (
      <div className="retail-portal-container">
        <div className="header">
          <div>Create New Coupons for Retail Store</div>
          {/* <button onClick={this.redirectToCoupon('new')}>+</button> */}
        </div>
        <Form onSubmit={this.handleSubmit} className="form-container">
          <RetailDiscountCouponDetail {...this} />
        </Form>
      </div>
    );
  }
}

export default withRouter(RetailPortalCreateNewCoupons);
